/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* werkbonnen.module.ts
* 1-3-2023 - Jelmer Jellema - Spin in het Web B.V.
*/

import {NgModule} from '@angular/core';
import {Werkbonnenlijstscherm} from './werkbonnenlijst';
import {SihwDatatable2Module} from 'sihw-ng/datatable2/datatable2.module';
import {Werkbonedit} from './werkbonedit';
import {SihwtijdveldModule} from 'sihw-ng/controls/sihwtijdveld/sihwtijdveld.module';
import {SihwdatumveldModule} from 'sihw-ng/controls/sihwdatumveld/sihwdatumveld.module';
import {SiwhFullselectModule} from 'sihw-ng/controls/selectdirective/fullselectdirective.module';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

const schermen = [
  Werkbonnenlijstscherm,
  Werkbonedit
];

@NgModule({
  declarations: schermen,
  imports: [
    CommonModule,
    SihwDatatable2Module,
    SihwtijdveldModule,
    SihwdatumveldModule,
    SiwhFullselectModule,
    FormsModule
  ],
  exports: schermen
})
export class WerkbonnenModule {
}

Werkbonnenlijstscherm.register('Werkbonnenlijstscherm');
Werkbonedit.register('Werkbonedit');
